module.exports = __webpack_public_path__ + "static/media/designPatent_30-1053856.0f852902.png";